// Chuẩn hoá path thành base-segment (phần đầu tiên) để so khớp route <-> menu.
// Dùng chung cho ProtectedRoute (check quyền theo path) và AuthDataProvider (phạm vi lớp theo route).

/** Lấy base-segment đầu tiên của path (bỏ dấu / ở đầu, bỏ query). Trả "" nếu rỗng. */
export const getBasePathSegment = (path: string): string => {
    if (!path || path.trim() === "") return "";
    let normalized = path.startsWith("/") ? path.slice(1) : path;
    normalized = normalized.split("?")[0];
    return normalized.split("/")[0] || "";
};

/** Base-segment của location.pathname; trả "dashboard" nếu rỗng hoặc "/". */
export const getLocationBaseSegment = (pathname: string): string => {
    if (!pathname || pathname === "/") return "dashboard";
    return getBasePathSegment(pathname) || "dashboard";
};
